import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import { AiFillStar } from "react-icons/ai";
import { GiGearStickPattern } from "react-icons/gi";
import { FaRoad, FaWheelchair, FaShareAlt } from "react-icons/fa";
import { IoMdCall } from "react-icons/io";
import { useHistory } from "react-router-dom";
import shortid from "shortid";
import { BiShow, BiHide } from "react-icons/bi";
import "./buttons.scss";
import { formatWavUrlString } from "../../Helpers/utils";
import { getWavBySlug, getWav } from "../../redux/actions/wavActions";
import { useDispatch } from "react-redux";

const SearchCard = ({ wav }) => {
  const history = useHistory();
  const [showNumber, setShowNumber] = useState(true);
  const shortenedText = wav.description.substring(0, 100);
  const dispatch = useDispatch()
  const navigate = (id) => {
    history.push(`/dealers/${id}`);
  };
  // const price = parseFloat(wav.price);
  let price = 0
  if (Object.entries(wav).length > 0) {
    wav.price_2 = wav.price.replace(/[^0-9]/g, "")
    price = parseFloat(wav.price_2);

    wav.mileage = wav.mileage.replaceAll(`\"`, "")

  }
  const phone_number = (Object.entries(wav).length > 0) && wav.owner && wav.owner.phone_number;

  if ((Object.entries(wav).length > 0) && wav.featured_image && wav.images) {
    let filtered = wav.images.filter((ele) => ele != wav.featured_image);
    wav.images = [wav.featured_image, ...filtered]
  }


  const getWavdetails = async (wavId) => {
    const resp = await dispatch(getWav(wavId));
    if (resp?.success) {
      var slug = resp?.data?.wav?.slug ? resp?.data?.wav?.slug : resp?.data?.wav?.title.replaceAll(' ', '_');
      history.push(`/wavs/${slug}`, {
        wav_id: wavId
      });
    }
  }

  return (
    <div className="card-main-content">
      <div className="card w-80 mt-5">
        <div
          className="card-top"
          style={{ cursor: "pointer" }}
          onClick={() => {
            getWavdetails(wav?._id)
            //   history.push(`/wavs/${wav._id}`, {
            //   wav_id: wav._id
            // })
            // dispatch(getWavBySlug(wav.slug, history));

            // history.push(`/wavs/${formatWavUrlString(wav)}`, {
            //   wav_id: wav._id
            // });

            // history.push(`/wavs/${wav.slug}`, {
            //   wav_id: wav._id
            // });

          }
          }
        >
          {/* <a href={window.location.origin + `/wavs/${formatWavUrlString(wav)}`} onClick={(event) => event.preventDefault()} style={{ textDecoration: "none" }}>
            {wav.title}
          </a> */}

          <a href={window.location.origin + `/wavs/${wav.slug}`} onClick={(event) => event.preventDefault()} style={{ textDecoration: "none" }}>
            {wav.title}
          </a>

          <p>
            <small>{shortenedText}...</small>
          </p>
        </div>
        <div className="card-body-carousel">
          <div className="left">
            <Carousel
              interval={null}
            >
              {wav.images.length > 0 &&
                wav.images.map((image, i) => (
                  <Carousel.Item key={i}>
                    <img
                      className="d-block w-100 img-fluid carousel-img"
                      src={`https://dev.wavcompare.com/uploads/${image.replace("images/", "images/thumbnails/")}`}
                      alt={`slide ${i}`}
                      style={{ maxHeight: "400px" }}
                      key={shortid.generate()}
                    />
                  </Carousel.Item>
                ))}
            </Carousel>
          </div>
          <div className="right">
            <div className="card-list-details">
              <ul>
                <li>
                  <div>Make</div> <div>{wav.make}</div>
                </li>
                <li>
                  <div>Year</div> <div>{wav.year}</div>
                </li>
                <li>
                  <div>Colour</div> <div>{wav.exterior_colour}</div>
                </li>
                <li>
                  <div>Fuel</div> <div>{wav.fuel_type}</div>
                </li>
                <li>
                  <div>Model</div> <div>{wav.models}</div>
                </li>
                <li>
                  <div>Condition</div> <div>{wav.condition}</div>
                </li>
                <li>
                  <div>Seating</div> <div>{wav.seating}</div>
                </li>
              </ul>
            </div>
            <div className="rest">
              <div className="card-icon-options">
                <div className="first-column">
                  <div>
                    <span>
                      <AiFillStar />
                    </span>
                    {wav.condition}
                  </div>
                  <div>
                    <span>
                      <FaRoad />
                    </span>
                    {wav.mileage}
                  </div>
                </div>
                <div className="second-column">
                  <div>
                    <span>
                      <GiGearStickPattern />
                    </span>
                    {wav.transmission}
                  </div>
                  <div>
                    <span>
                      <FaWheelchair />
                    </span>
                    {wav.seating}
                  </div>
                </div>
              </div>
              <div className="card-contact-details">
                {/* <ul>
                  <li>
                    <img
                      src={
                        wav && wav.owner && wav.owner.logo !== ""
                          ? `https://dev.wavcompare.com/uploads/${wav.owner.logo}`
                          : "/assets/user.jpg"
                      }
                      className="owner-img"
                      alt=""
                    />
                  </li>
                  <li className="number">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(wav.owner._id)}
                    >
                      {wav && wav.owner && wav.owner.name}
                    </div>
                    <IoMdCall />{" "}
                    {phone_number && (showNumber
                      ? phone_number
                      : `${phone_number.substring(0, 4)}*****`)}
                    <span onClick={() => setShowNumber(!showNumber)}>
                      {showNumber ? <BiHide /> : <BiShow />}
                    </span>
                  </li>
                </ul> */}
                {/* <button className="btn btn-outline-secondary btn-small share-this">
                  <span className="mr-3">
                    <FaShareAlt color="#28b8cb" />
                  </span>
                  SHARE THIS
                </button> */}
              </div>
              <div className="card-buttons">
                <a href="" style={{ cursor: "default" }} className="price-btn" onClick={(event) => event.preventDefault()}>
                  <span>£{price.toLocaleString()}</span>
                </a>
                <a
                  onClick={(event) => {
                    //   history.push(`/wavs/${wav._id}`, {
                    //   wav_id: wav._id
                    // })
                    event.preventDefault()
                    // history.push(`/wavs/${formatWavUrlString(wav)}`, {
                    //   wav_id: wav._id
                    // });

                    dispatch(getWavBySlug(wav.slug, history));

                    history.push(`/wavs/${wav.slug}`, {
                      wav_id: wav._id
                    });


                  }
                  }
                  // href={window.location.origin + `/wavs/${formatWavUrlString(wav)}`}
                  href={window.location.origin + `/wavs/${wav.slug}`}
                  className="enquire-btn"
                >
                  <span>ENQUIRE NOW</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchCard;
